import { WishlistOrderChanged } from '@studyportals/wishlist-service-core';
import { WishlistCache } from '../infrastructure/wishlist-cache';
import { WebsocketWishlistOrderChangedSubscriber } from './websocket-wishlist-order-changed-subscriber';
import { IEventAggregationService } from '@studyportals/event-aggregation-service-interface';
import { IWebSocketService } from '../../../interfaces';

export class WebsocketWishlistOrderChangedAdapter {
	constructor(
		private readonly webSocketService: IWebSocketService,
		private readonly eventAggregationService: IEventAggregationService,
		private wishlistCache: WishlistCache,
	) {}

	public initialize(): void {
		this.webSocketService.subscribeToWebSocketEvent(
			WishlistOrderChanged.EventType,
			new WebsocketWishlistOrderChangedSubscriber(this.eventAggregationService, this.wishlistCache),
		);
	}
}
